import { Button } from "@gravity-ui/uikit";
import Editor from "@monaco-editor/react";
import { useAction, useAtom } from "@reatom/npm-react";
import { editor } from "monaco-editor";
import { useMemo } from "react";
import { useTranslate } from "src/i18n";
import { updateProductSelectionRequest } from "src/pages/ProductPage/widgets/ProductSamples/store/fetchers/updateProductSelectionRequest";
import { productSelectionStore } from "src/store/atoms";
import { deepEqual, downloadObjectAsJson, toastHandler } from "src/util";

import css from "./SpuIdsEditor.module.scss";

const options: editor.IStandaloneEditorConstructionOptions = {};

export const SpuIdsEditor = () => {
  const [jsonSelectedSpuId] = useAtom(productSelectionStore.selectedJsonAtom);
  const [arraySelectedSpuId] = useAtom(productSelectionStore.selectedArrayAtom);
  const updateSelection = useAction(updateProductSelectionRequest);
  const [updateSelectionIsLoading] = useAtom(
    updateProductSelectionRequest.isLoadingAtom,
  );
  const [productSample, setProductSample] = useAtom(
    productSelectionStore.currentSelectionAtom,
  );
  const { t } = useTranslate();

  const setSelectedSpuId = useAction(
    productSelectionStore.setSelectedIdsActionWithDebounce,
  );

  const isDirty = useMemo(
    () => !deepEqual(arraySelectedSpuId, productSample?.productIds),
    [arraySelectedSpuId, productSample?.productIds],
  );

  return (
    <div className={css.container}>
      <Editor
        height="400px"
        defaultLanguage="json"
        defaultValue="[]"
        theme="vs-dark"
        value={jsonSelectedSpuId}
        onChange={(e) => {
          setSelectedSpuId(JSON.parse(e || "[]"));
        }}
        options={options}
      />
      <div className={css.buttonsWrapper}>
        <Button
          type="button"
          view="action"
          size="m"
          disabled={!isDirty}
          loading={updateSelectionIsLoading}
          onClick={async () => {
            if (productSample) {
              const res = await updateSelection(productSample?.id, {
                name: productSample?.name,
                productIds: arraySelectedSpuId,
              });

              if (res) setProductSample(res);
            }
          }}
        >
          {t("save", "Сохранить")}
        </Button>
        <div className={css.buttonsWithGap}>
          <Button
            type="button"
            view="normal"
            size="m"
            onClick={() => {
              navigator.clipboard.writeText(jsonSelectedSpuId);
              return toastHandler.success({
                title: t("success", "Успех"),
                content: t(
                  "spu_ids_copied_successfully",
                  "Список товаров скопирован успешно",
                ),
                name: "exporterCopySpuIds",
              });
            }}
          >
            {t("copy", "Копировать")}
          </Button>
          <Button
            type="button"
            view="action"
            size="m"
            onClick={() => {
              downloadObjectAsJson(jsonSelectedSpuId, "spuIds");
            }}
          >
            {t("download", "Скачать")}
          </Button>
        </div>
      </div>
    </div>
  );
};
